<template>
  <div class="policy-image-page">
    <!-- 顶部标题栏 -->
    <div class="header">
      <div class="back-btn" @click="$router.back()">
        <i class="fa-solid fa-chevron-left"></i>
      </div>
      <h1 class="title">政策详情</h1>
    </div>

    <!-- 长图展示 -->
    <div class="image-container">
      <img
        src="/微信图片_2026-08-29_000227_289.jpg"
        alt="政策详情图"
        class="policy-image"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PolicyImage'
}
</script>

<style scoped>
.policy-image-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  padding: 0 15px;
  z-index: 100;
}

.back-btn {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  cursor: pointer;
}

.title {
  flex: 1;
  text-align: center;
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin-right: 30px;
}

.image-container {
  padding-top: 50px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.policy-image {
  width: 100%;
  height: auto;
  display: block;
}
</style>
